import TopStrengths from './TopStrengths'

export default TopStrengths
